import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { LoginPopUp } from '..';
import { useBraze } from '../../hooks/useBraze';

const LoginPopUpWrapper = (props) => {
    const { brazeInstance } = useBraze();
    const userId = useSelector(({ auth }) => auth?.user?.id);

    useEffect(() => {
        if (brazeInstance && userId) {
            const brazeUser = brazeInstance.getUser();
            const brazeUserId = brazeUser ? parseInt(brazeUser.getUserId(), 10) : null;
            if (brazeUserId !== userId) {
                brazeInstance.changeUser(userId);
            }
        }
    }, [brazeInstance, userId]);

    return (
        <LoginPopUp {...props} />
    );
};

export default LoginPopUpWrapper;
